import { interceptAxios } from '@patsnap-utils/passport';
import { psAxios } from '@patsnap/common-ps-http';

window.psAxios = psAxios;
/**
 * 注入 passport 拦截器
 * @description 用于 token base 认证
 */
export function injectPassportInterceptor() {
    if (!psAxios.psInterceptors.passportRequestInterceptor) {
        interceptAxios(psAxios);
    }
}

/**
 * 移除 passport 拦截器
 */
export function ejectPassportInterceptor() {
    if (psAxios.psInterceptors.passportRequestInterceptor) {
        psAxios.interceptors.request.eject(psAxios.psInterceptors.passportRequestInterceptor);
        delete psAxios.psInterceptors.passportRequestInterceptor;
    }
    if (psAxios.psInterceptors.passportResponseInterceptor) {
        psAxios.interceptors.response.eject(psAxios.psInterceptors.passportResponseInterceptor);
        delete psAxios.psInterceptors.passportResponseInterceptor;
    }
}
